var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"block text-black text-xl my-12"},[_vm._v(" Page not found ")]),(_vm.loggedIn)?_c('router-link',{staticClass:"primary-button inline-block",attrs:{"to":{
      name: 'company',
      params: {
        companyId:
          _vm.currentUser.default_company_id &&
          _vm.currentUser.default_company_id !== 0
            ? _vm.currentUser.default_company_id
            : _vm.currentUser.companies[0].id,
      },
    }}},[_vm._v("Go to home")]):_vm._e(),(!_vm.loggedIn)?_c('router-link',{staticClass:"primary-button inline-block",attrs:{"to":{
      name: 'login',
    }}},[_vm._v("Login")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }